import 'owl.carousel';

export default function (obj) {
    obj.find(".herald-widget-slider").each(function () {
        var $controls = $(this).closest('.widget').find('.herald-slider-controls');
        $(this).owlCarousel({
            rtl: herald_js_settings.rtl_mode === "true",
            loop: true,
            autoHeight: false,
            autoWidth: false,
            nav: true,
            center: false,
            fluidSpeed: 100,
            navContainer: $controls,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    autoWidth: false,
                    margin: 20,
                    items: 1
                }
            }
        });
    });
}
